module.exports = __webpack_public_path__ + "static/img/kv_deco_01.cb600a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/kv_deco_01.png
// module id = JFn8
// module chunks = 0